import React, {useEffect, useState} from "react";
import {Col, message, Row} from "antd";
import bannerApi from "../../api/banner";
import HhxCarousel from "../../compenents/carousel";
import Demand from "./compenents/demand";
import ContactUs from "./compenents/contact-us";

const AboutPage = () => {

    const [images, setImages] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        bannerApi.list({
            type: bannerApi.BannerType.ABOUT_US,
        }).then(res => {
            setImages(res.data.map(item => ({
                id: item.id,
                imgUrl: item.imgUrl,
                jumpUrl: item.jumpUrl,
            })))
        }).catch(e => messageApi.error(e.msg))
    }, [messageApi]);

    const handleCarouselClick = (url) => window.open(url, "_blank");

    return (
        <div>
            {contextHolder}
            <HhxCarousel images={images} onClick={handleCarouselClick}/>
            <div className="section" style={{backgroundColor: "initial"}}>
                <div className="container">
                    <Row gutter={64}>
                        <Col span={12}>
                            <Demand/>
                        </Col>
                        <Col span={12}>
                            <ContactUs/>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default AboutPage